var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .5c5.385 0 10.26 2.183 13.789 5.711A19.439 19.439 0 0 1 39.5 20c0 5.385-2.183 10.26-5.711 13.789A19.439 19.439 0 0 1 20 39.5a19.439 19.439 0 0 1-13.789-5.711A19.439 19.439 0 0 1 .5 20c0-5.385 2.183-10.26 5.711-13.789A19.439 19.439 0 0 1 20 .5z",
    stroke: "#ECECEC",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.594 25.073-6.923-4.608 6.923-5.765v10.373zm-.703 2.242H10.109a.704.704 0 0 1-.689-.563s2.68-1.782 8.037-5.348l.806.671a2.709 2.709 0 0 0 3.474 0l.806-.671 8.037 5.348a.704.704 0 0 1-.69.563zM9.406 14.7l6.923 5.765-6.923 4.608V14.7zm20.21-1.015-.282.234-8.497 7.076a1.308 1.308 0 0 1-1.674 0l-8.497-7.076-.281-.234h19.23zm.275-1.406H10.109c-1.163 0-2.109.946-2.109 2.11v12.223c0 1.163.946 2.11 2.11 2.11h19.78c1.164 0 2.11-.947 2.11-2.11V14.388c0-1.163-.946-2.11-2.11-2.11z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e972fcc60461ce25dd5748ad31e45c7e.svg";
export { ForwardRef as ReactComponent };